"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPassengerCoveredByThirdPartyAgreement = exports.getThirdPartyAgreement = exports.defaultLegalMentionDetails = exports.makeLegalMention = exports.invoiceablePaymentStatuses = exports.getPeriod = exports.getLastCompletedPeriod = void 0;
exports.getTimeSlot = getTimeSlot;
var moment_1 = __importDefault(require("@ambler/moment"));
var _1 = require(".");
var agreements_1 = require("./agreements");
function getTimeSlot(departureTime, arrivalTime) {
    var arrival = (0, moment_1.default)(arrivalTime);
    var departure = (0, moment_1.default)(departureTime);
    var center = (0, moment_1.default)(moment_1.default.range(arrival, departure).center());
    var _8h = (0, moment_1.default)(departure).set({ hour: 8, minute: 0, second: 0 });
    var _12h = (0, moment_1.default)(departure).set({ hour: 12, minute: 0, second: 0 });
    var _20h = (0, moment_1.default)(departure).set({ hour: 20, minute: 0, second: 0 });
    var _8h_tomorrow = (0, moment_1.default)(departure).add(1, 'd').set({ hour: 8, minute: 0, second: 0 });
    var _20h_yesterday = (0, moment_1.default)(departure).subtract(1, 'd').set({ hour: 20, minute: 0, second: 0 });
    if ((departure.isSameOrAfter(_20h) && arrival.isSameOrBefore(_8h_tomorrow)) ||
        (departure.isSameOrAfter(_20h_yesterday) && arrival.isSameOrBefore(_8h)) ||
        (departure.isSameOrBefore(_20h) && arrival.isSameOrAfter(_20h) && center.isSameOrAfter(_20h)) ||
        (departure.isSameOrBefore(_8h) && arrival.isSameOrAfter(_8h) && center.isSameOrBefore(_8h))) {
        return 'NIGHT';
    }
    else if (center.isoWeekday() === 6 && center.isSameOrAfter(_12h) && center.isSameOrBefore(_20h)) {
        return 'SATURDAY';
    }
    else if (center.isoWeekday() === 7 && center.isSameOrAfter(_8h) && center.isSameOrBefore(_20h)) {
        return 'SUNDAY';
    }
    else if (center.isWorkingDay() === false && center.isSameOrAfter(_8h) && center.isSameOrBefore(_20h)) {
        return 'HOLIDAY';
    }
    return 'WEEKDAY';
}
var getLastCompletedPeriod = function (frequency, now) {
    var _a = (function () {
        switch (frequency) {
            case 'MONTHLY':
                return [(0, moment_1.default)(now).startOf('month').subtract(1, 'month'), (0, moment_1.default)(now).startOf('month')];
            case 'WEEKLY':
                return [(0, moment_1.default)(now).startOf('week').subtract(1, 'week'), (0, moment_1.default)(now).startOf('week')];
            case 'SEMI_MONTHLY': {
                var monthMiddle = (0, moment_1.default)(now).date(16).startOf('day');
                if ((0, moment_1.default)(now) > monthMiddle) {
                    return [(0, moment_1.default)(now).startOf('month'), monthMiddle];
                }
                else {
                    return [monthMiddle.subtract(1, 'month'), (0, moment_1.default)(now).startOf('month')];
                }
            }
        }
        (0, _1.assertUnreachable)(frequency);
    })(), start = _a[0], end = _a[1];
    return {
        startDate: start.toDate(),
        endDate: end.toDate(),
    };
};
exports.getLastCompletedPeriod = getLastCompletedPeriod;
var getPeriod = function (frequency, departureTime) {
    var _a = (function () {
        switch (frequency) {
            case 'MONTHLY':
                return [(0, moment_1.default)(departureTime).startOf('month'), (0, moment_1.default)(departureTime).startOf('month').add(1, 'month')];
            case 'WEEKLY':
                return [(0, moment_1.default)(departureTime).startOf('week'), (0, moment_1.default)(departureTime).startOf('week').add(1, 'week')];
            case 'SEMI_MONTHLY': {
                var monthMiddle = (0, moment_1.default)(departureTime).date(16).startOf('day');
                if ((0, moment_1.default)(departureTime).isSameOrAfter(monthMiddle)) {
                    return [monthMiddle, (0, moment_1.default)(departureTime).startOf('month').add(1, 'month')];
                }
                else {
                    return [(0, moment_1.default)(departureTime).startOf('month'), monthMiddle];
                }
            }
        }
        (0, _1.assertUnreachable)(frequency);
    })(), start = _a[0], end = _a[1];
    return {
        startDate: start.toDate(),
        endDate: end.toDate(),
    };
};
exports.getPeriod = getPeriod;
exports.invoiceablePaymentStatuses = [
    'DI_HPTLA',
    'DI_HPTLA_HPTLB',
    'DI_HPTLA_PTNT',
    'HPTLA',
    'HPTLA_HPTLB',
    'HPTLA_PTNT',
];
var makeLegalMention = function (paymentModality, paymentDelay) {
    switch (paymentModality) {
        case 'DAYS':
            return "Payable sous ".concat(paymentDelay, " jours \u00E0 compter de la r\u00E9ception de la facture. \n");
        case 'DAYS_END_OF_MONTH':
            return "Payable sous ".concat(paymentDelay, " jours fin de mois \u00E0 compter de la r\u00E9ception de la facture (Conditions de r\u00E8glement: ").concat(paymentDelay, " jours fin de mois \u00E0 la date d'\u00E9mission de la facture, la limite de paiement intervenant \u00E0 la fin du mois au cours duquel expirent ces ").concat(paymentDelay, " jours). \n");
    }
    (0, _1.assertUnreachable)(paymentModality);
};
exports.makeLegalMention = makeLegalMention;
exports.defaultLegalMentionDetails = 'Escompte en cas de paiement anticipé : Néant.\n\nPénalités de retard : trois fois le taux annuel d’intérêt légal en vigueur calculé depuis la date d’échéance jusqu’à complet paiement du prix.\nIndemnité forfaitaire pour frais de recouvrement en cas de retard de paiement : 40 €';
var getThirdPartyAgreement = function (passenger) {
    var _a, _b;
    return (_b = (_a = passenger.priceInfo) === null || _a === void 0 ? void 0 : _a.pricing) === null || _b === void 0 ? void 0 : _b.agreement;
};
exports.getThirdPartyAgreement = getThirdPartyAgreement;
var isPassengerCoveredByThirdPartyAgreement = function (passenger) {
    var departureTime = passenger.departureTime;
    var agreement = (0, exports.getThirdPartyAgreement)(passenger);
    var isCoveredByAgreement = Boolean(departureTime &&
        agreement &&
        (0, agreements_1.is3PAgreement)(agreement.type) &&
        (0, moment_1.default)(departureTime).isBetweenOrIsAfter(agreement.startDate, agreement === null || agreement === void 0 ? void 0 : agreement.endDate));
    return isCoveredByAgreement;
};
exports.isPassengerCoveredByThirdPartyAgreement = isPassengerCoveredByThirdPartyAgreement;
//# sourceMappingURL=invoicing.js.map